import { format } from 'date-fns'
import { getCurrentInstance } from '@vue/composition-api'
/**
 * 判断是否属于
 * @param {*} value
 * @param {*} validList
 */
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

/**
 * 时间戳转换
 */
export function formatTime(val, type) {
  if (val) {
    let time = parseInt(val, 10)
    if (type === 'toDay') {
      return format(time, 'yyyy-MM-dd')
    } else {
      return format(time, 'yyyy-MM-dd HH:mm')
    }
  }
  return ''
}

/**
 * 获取Url上的参数
 * @param {*} name
 */
export function getParamsValue(name) {
  const reg = new RegExp('[?&]' + name + '=([^&#]*)', 'i')
  const res = window.location.href.match(reg)

  if (res && res.length > 1) {
    return decodeURIComponent(res[1])
  }
  return false
}

// 设置localStorage
export const setStorage = function (key, obj) {
  let json = JSON.stringify(obj)
  window?.localStorage.setItem(key, json)
}

// 获取localStorage
export const getStorage = function (key) {
  const str = window?.localStorage.getItem(key)
  if (!str) {
    return null
  }
  try {
    return JSON.parse(str)
  } catch (e) {
    console.log(e)
    return str
  }
}

// 移除localStorage
export const removeStorage = function (key) {
  window.localStorage.removeItem(key)
}

// 获取浏览器默认语言
export const getBrowserLang = function () {
  let browserLang = navigator.language
    ? navigator.language
    : navigator.browserLanguage
  let defaultBrowserLang = ''
  if (
    browserLang.toLowerCase() === 'cn' ||
    browserLang.toLowerCase() === 'zh' ||
    browserLang.toLowerCase() === 'zh-cn' ||
    browserLang.toLowerCase() === 'zh-tw'
  ) {
    defaultBrowserLang = 'zh'
  } else {
    defaultBrowserLang = 'en'
  }
  return defaultBrowserLang
}

//i18n 国际化
export const tran = function(initParam){
  let vm = getCurrentInstance()
  return vm?.proxy.$t(initParam) as string
}

// 保留N为小数
export function decimal(num, v, isRound) {
  if (typeof (num) === 'undefined' || num === null || num === 'undefined') {
    return '';
  }
  // 如果为NaN直接返回num
  if (isNaN(num)) {
    return num;
  }
  if (typeof (num) === 'string') {
    let num = Number(num);
  }
  const vv = Math.pow(10, v);
  //是否四舍五入
  if (isRound) {
    const pointPosition = (num + '').indexOf('.');
    // 是否为小数
    if (pointPosition != -1) {
      const fixStr = (num + '').slice(pointPosition);
      // 是否大于指定小数位数
      if (fixStr.length >= v) {
        return (num + '').substring(0, pointPosition + v + 1)
      } else {
        return (Math.round(num * vv) / vv).toFixed(v);
      }
    } else {
      // return (Math.round(num * vv) / vv).toFixed(v);
      // 如果不是小数直接返回
      return num;
    }
  } else {
    return (Math.round(num * vv) / vv).toFixed(v);
  }
}

// 数字用千分位隔开
export function thousandSeparatorFormater(value) {
  let n = value;
  let isNegativeNumber = false;
  // 如果为NaN直接返回value
  if (value == null) {
    return;
  }
  if (isNaN(value)) {
    return value;
  }
  // 如果字符串转换为number
  if (typeof (value) === 'string') {
    n = Number(value);
  }
  if (n < 0) {
    isNegativeNumber = true;
    n = Math.abs(n);
  }
  if (typeof n !== 'string') {
    n = n.toString();
  }
  const re = /\d{1,3}(?=(\d{3})+$)/g;
  let n1 = n.replace(/^(\d+)((\.\d+)?)$/, (s, s1, s2) => { return s1.replace(re, '$&,') + s2; });
  // 如果为负数要增加负数符号
  if (isNegativeNumber) {
    n1 = `-${n1}`;
  }
  return n1;
}

//判断是否超出，给tooltip
export function textRange (el) {
  const textContent = el
  const targetW = textContent.getBoundingClientRect().width
  const range = document.createRange()
  range.setStart(textContent, 0)
  range.setEnd(textContent, textContent.childNodes.length)
  const rangeWidth = range.getBoundingClientRect().width
  return rangeWidth > targetW
}

//获取全部的 url参数
export function getAllUrlQuery() {
  let resObj = {}
  const [leftUrl,queryStr] = decodeURIComponent(window.location.href).split('?')
  let query = queryStr?.split('&') ?? []
  query.forEach(ele=>{
    const [key,value] = ele.split('=')
    resObj[key] = value
  })
  return resObj
}

/**
 * @description  //自适应表格列宽
 * @param params
 * str column name 
 * tableData table origin data
 * flag : 1.max(fit longest content) 2.equal(fit first line content)
 * @returns
 */
export function autoFitColumnWidth(str, tableData, flag = 'max') {
  let columnContent = ''
  if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
    return
  }
  if (!str || !str.length || str.length === 0 || str === undefined) {
    return
  }
  if (flag === 'equal') {
    // 获取该列中第一个不为空的数据(内容)
    for (let i = 0; i < tableData.length; i++) {
      if (tableData[i][str].length > 0) {
        columnContent = tableData[i][str]
        break
      }
    }
  } else {
    // 获取该列中最长的数据(内容)
    let index = 0
    for (let i = 0; i < tableData.length; i++) {
      if (tableData[i][str] === null) {
        return
      }
      const now_temp = tableData[i]?.[str]
      const max_temp = tableData[index]?.[str]
      if (now_temp?.length >= max_temp?.length) {
        index = i
      }
    }
    columnContent = tableData[index][str]?.toString() ?? ''
  }
  // 以下分配的单位长度可根据实际需求进行调整
  let flexWidth = 0
  for (const char of columnContent) {
    if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
      // 如果是英文字符，为字符分配8个单位宽度
      flexWidth += 8
    } else if (char >= '\u4e00' && char <= '\u9fa5') {
      // 如果是中文字符，为字符分配18个单位宽度
      flexWidth += 15
    } else {
      // 其他种类字符，为字符分配15个单位宽度
      flexWidth += 8
    }
  }
  if (flexWidth < 120) {
    // 设置最小宽度
    flexWidth = 120
  }
  return flexWidth
}